/**
 *
 * UserTags
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import Tag from 'components/interaction/Tag/index.jsx';
import IntlString from 'components/media/IntlString/index.jsx';
import UserAvatar from 'components/user/UserAvatar/index.jsx';
import { removeUser } from 'utils/sameRole.js';
import { getIdNumber } from 'utils/userIdRole.js';

function UserTags(props) {
  const { disabled, value = [], onChange, prompt, exclusions } = props;
  const handleRemove = (user) => {
    const newValues = removeUser(value, user);
    onChange(newValues);
  };
  const filtered = exclusions ? value.filter((o) => !exclusions.includes(getIdNumber(o))) : value;
  if (filtered.length === 0) {
    return <div className="fst-italic input-height text-muted"><IntlString message={prompt} /></div>;
  }
  return (
    <div className="d-inline-flex align-items-center flex-wrap">
      {filtered.map((user) => (
        <Tag key={[user.id, user.roleType]} className="me-3 my-2" onRemove={disabled ? undefined : () => handleRemove(user)}>
          <UserAvatar bsSize="small" user={user} align="center" />
        </Tag>
      ))}
    </div>
  );
}

UserTags.propTypes = {
  disabled: PropTypes.bool,
  value: PropTypes.array,
  exclusions: PropTypes.array,
  onChange: PropTypes.func,
  prompt: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

export default UserTags;
